
import React from 'react';
import { withStyles, withRouter } from '../../material-ui';
import SubscribeAnchor from './SubscribeAnchor';
import AppUtils from '../../control/apputlis';
import AppData from '../../model/AppData';
import MBack from '../view/MBack';


class MatchLeague extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dayData: [],
            hotData: [],
            value: AppUtils.getStorageInt(AppUtils.SUBSCRIBE_INDEX),
        };
    }

    _handleChange(val) {
        AppUtils.YMPush('MAIN', 'MatchLeague');
        this.setState({ value: val });
        AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, val);
    }

    componentDidMount() {
        let { os, token, customerId } = this.props.match.params;
        AppData.me.token = token;
        AppData.me.customer_id = customerId;
        // if (!AppData.me.isLogin()) {
        //     AppData.login();
        // }

        if (os && os != '' && os != '0') {
            AppData.os = os
        }
        AppData.checkUpdate();


    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    render() {
        const { value } = this.state;
        // let { nav } = this.props.match.params;
        let hideBack = true;
        if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
            hideBack = false;
        }
        // if (nav == 1) {
        //     hideBack = false;
        // }

        return (
            <MBack title="关注主播" >
                <SubscribeAnchor />

            </MBack>

            // <MPage backgroundColor='#FFF' Header={
            //     <Grid container direction='column' alignItems='center'>
            //         <Grid container direction='column' alignItems='center' style={{ boxShadow: '1px 1px 3px #F0F0F0', backgroundColor: '#FFF' }}>
            //             <MStatusBar />
            //             <Grid container direction='row' justifyContent='center' alignItems='center' >
            //                 <Tabs
            //                     value={value}
            //                     onChange={(e, val) => this._handleChange(val)}
            //                     TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
            //                 >
            //                     <Tab label='主播' style={{ color: '#0D0D0D', opacity: 1, fontSize: value == 0 ? 17 : 14, fontWeight: value == 0 ? 'bold' : 'inherit' }}></Tab>
            //                     <Tab label='赛事' style={{ color: '#0D0D0D', opacity: 1, fontSize: value == 1 ? 17 : 14, fontWeight: value == 1 ? 'bold' : 'inherit' }}></Tab>
            //                 </Tabs>
            //                 {
            //                     hideBack && <IconButton onClick={() => window.history.back()} style={{ position: 'absolute', left: 10 }}>
            //                         <ArrowBackIosIcon style={{ fontSize: 17, color: '#0D0D0D' }} />
            //                     </IconButton>
            //                 }
            //             </Grid>
            //         </Grid>
            //     </ Grid>
            // }>
            //     <MTabPanel value={value} index='0' >
            //         <SubscribeAnchor />
            //     </MTabPanel>
            //     <MTabPanel value={value} index='1' >
            //         <SubscribeMatch />
            //     </MTabPanel>

            //     {/* <MEnvelope bottom={123} /> */}
            // </MPage>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        backgroundSize: 'cover',
        width: '100vw',
        height: '100vh',
        display: "flex",
        backgroundColor: '#FFF',
        flexDirection: "column",
        alignItems: 'center',
    },
    subheader: {
        width: '100%',
        padding: theme.spacing(0, 0, 0, 0),
        backgroundColor: '#FFF',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
}))(MatchLeague));